import { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { ArrowLeftIcon, ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import useModel3DViewer from "../../pages/Customiz3r/Editor3D/useModel3DViewer.js";
import ModelViewerShell from "../Viewer3D/ModelViewerShell.jsx";

/**
 * Un modelo del catálogo en 3D (C3D-38), con el visor común (C3D-12).
 *
 * `glbUrl` es el del catálogo público o el del perfil del usuario; en el
 * perfil hace falta la sesión (`withAuth`), porque el diseño no es suyo.
 */
export default function CatalogItemViewer({ glbUrl, withAuth = false, title, onBack, backLabel, enquiryUrl, extraActions = [] }) {
    const accessToken = withAuth ? localStorage.getItem("access_token") : null;
    const requestHeaders = useMemo(
        () => (accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined),
        [accessToken],
    );
    const handleLoadError = useCallback((err, { setError, setLoading }) => {
        console.error("Error cargando el modelo del catálogo:", err);
        setError("No se ha podido cargar este modelo en 3D.");
        setLoading(false);
    }, []);

    const viewer = useModel3DViewer({ glbUrl, requestHeaders, bottomLight: true, onLoadError: handleLoadError });

    const actions = [
        ...extraActions,
        ...(enquiryUrl ? [{
            key: "enquiry",
            icon: ChatBubbleLeftRightIcon,
            label: "Consultar por WhatsApp",
            mobileLabel: "Consultar",
            tip: "Preguntar por este modelo por WhatsApp",
            onClick: () => window.open(enquiryUrl, "_blank", "noopener,noreferrer"),
            isPrimary: true,
        }] : []),
    ];

    return (
        <ModelViewerShell
            viewer={viewer}
            subtitle="Catálogo"
            loadingTitle="Cargando modelo 3D"
            errorBack={{ label: backLabel, onClick: onBack }}
            back={{ label: backLabel, tip: backLabel, icon: ArrowLeftIcon, onClick: onBack }}
            modelName={title || "Modelo 3D"}
            formData={null}
            canEditColors={false}
            actions={actions}
        />
    );
}

CatalogItemViewer.propTypes = {
    glbUrl: PropTypes.string,
    withAuth: PropTypes.bool,
    title: PropTypes.string,
    onBack: PropTypes.func.isRequired,
    backLabel: PropTypes.string.isRequired,
    enquiryUrl: PropTypes.string,
    extraActions: PropTypes.array,
};
